import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterState,
  RouterStateSnapshot
} from '@angular/router';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
})
export class InicioComponent implements OnInit {
  showElement: boolean;
  selected: string;
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.params.subscribe(() => {
      const state: RouterState = router.routerState;
      const snapshot: RouterStateSnapshot = state.snapshot;
      if (snapshot.url === '/') {
        this.router.navigate(['/inicio']);
      }
    });
  }

  ngOnInit(): void {
    this.showElement = false;
    /*setTimeout(() => {
      this.showElement = false;
    }, 4000);*/
  }

  goTo(url: string): void {
    this.selected = '';
    this.router.navigate([url]);
  }

  change(): void { }
}
